import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { makeSequence } from 'dpl/shared/utils';

const TOTAL_RATING_COUNT = 5;

export default function RatingBar({ title, rating }) {
  return (
    <div className="f3 f4-xl dark-gray tc">
      <div className="flex justify-between mb5">
        <p>{title}</p>
        <p>
          {rating}/{TOTAL_RATING_COUNT}
        </p>
      </div>
      <ul className="flex mw-100" style={{ gap: 2 }}>
        {makeSequence(TOTAL_RATING_COUNT).map(ratingIndex => (
          <li
            key={ratingIndex}
            className={classnames(
              'w-100',
              rating > ratingIndex ? 'bg-stone-700' : 'bg-light-gray',
              ratingIndex === 0 && 'br-pill br--top-right br--bottom-right',
              ratingIndex === TOTAL_RATING_COUNT - 1 &&
                'br-pill br--top-left br--bottom-left'
            )}
            style={{ height: 4 }}
          />
        ))}
      </ul>
    </div>
  );
}

RatingBar.propTypes = {
  title: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired
};
